module.exports = __webpack_public_path__ + "img/icon-global.61c06f6b.png";